module.exports = __webpack_public_path__ + "static/img/3diamond-card@3x.f8846f9e.png";